import { render, staticRenderFns } from "./OutsourcingPricing.vue?vue&type=template&id=190d1940&scoped=true&"
import script from "./OutsourcingPricing.vue?vue&type=script&lang=js&"
export * from "./OutsourcingPricing.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingPricing.vue?vue&type=style&index=0&id=190d1940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d1940",
  null
  
)

export default component.exports